module.exports = __webpack_public_path__ + "img/coins-balance-pay.5ab77bbf.png";